import * as Sentry from '@sentry/tanstackstart-react'
import { createRouter } from '@tanstack/react-router'
import { NotFoundPage } from '@/components/not-found'
import { routeTree } from './routeTree.gen'

export function getRouter() {
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    // Preload a route's loader on hover/touch, so the click is usually instant.
    // The top loading bar (<NavigationProgress/>, mounted in __root) covers any
    // residual wait — see src/components/navigation-progress.tsx.
    defaultPreload: 'intent',
    // `createRootRoute`'s own `notFoundComponent` only fires when the *root*
    // match itself is the not-found boundary (e.g. an invalid locale segment,
    // or no route at all). The much more common case — valid locale, no
    // matching child route (`/fr/old-slug`) — resolves its boundary at
    // `/$locale` and falls back to this router-level default instead;
    // without it, TanStack Router renders its bare `<p>Not Found</p>`.
    // Confirmed by hitting a built server: `/fr/x` showed unstyled text
    // nested in the normal header/footer until this was added.
    //
    // No explicit setResponseStatus(404) anywhere (plan's Task 3 was
    // skipped on purpose): TanStack Start sets the HTTP status to 404
    // implicitly whenever a notFoundComponent renders — confirmed via
    // curl on /fr/xxx, /en/xxx, /de/x, /foobar (all 404). Load-bearing
    // for SEO; if a future TanStack Start upgrade stops doing this
    // implicitly, an explicit setResponseStatus call needs to come back.
    defaultNotFoundComponent: () => <NotFoundPage />,
  })

  // Client-only: instruments SPA navigations as tracing transactions. Guarded by
  // isServer so it never runs during SSR (where there is no browser to trace).
  if (!router.isServer) {
    Sentry.addIntegration(Sentry.tanstackRouterBrowserTracingIntegration(router))
  }

  return router
}
